/** @format */
import { createAuthClient } from '@mpb-com/auth-sdk/client';

export const authClient = createAuthClient({
    httpClientConfig: { baseUrl: '', withCredentials: true },
});
